<template>
    <v-app>
        <v-slide-y-transition mode="out-in">
            <component :class="{'portal-layout': !$route.path.includes('/nettbutikk'), 'webshop-layout': $route.path.includes('/nettbutikk') || $route.query.chainId}" v-bind:is="layout"></component>
        </v-slide-y-transition>
    </v-app>
</template>

<script>
   import SimpleLayout from '@/layouts/SimpleLayout'
   import PortalLayout from '@/layouts/PortalLayout'
   import ChainLayout from '@/layouts/ChainLayout'
   import { mapWaitingActions } from "vue-wait";

   export default {
      computed: {
         layout() {
            return this.$store.getters['app/layout']
         }
      },
      methods: {
         ...mapWaitingActions('user', {
            userLoggedInActions: 'loading user userLoggedInActions',
            userLoggedOut: 'loading user userLoggedOut',
         }),


         async onUserLoggedIn() {
            this.fetchUserTags();
            
            this.userLoggedInActions({user: this.$user, route: this.$route});
         },

         onUserLoggedOut() {
            this.fetchUserTags();
            
            this.$store.dispatch('user/userLoggedOut');
         },

         async fetchUserTags() {
            await this.$store.dispatch('user/getUserTags');
         },
      },
      components: {
         // Empty layout
         SimpleLayout, // Initially selected

         // Fixit.no portal main menu layout
         PortalLayout, // Fallback (default)

         // Additional templates
         ChainLayout // Webshop
      },
      created() {
         // Listen for login/logout and refetch the userTags
         this.$eventBus.$on('user-logged-in', this.onUserLoggedIn);
         this.$eventBus.$on('user-logged-out', this.onUserLoggedOut);
         this.fetchUserTags();
      }
   }
</script>

<style lang="scss">
@import '~@/styles/app';
</style>
